import request from "@/utils/request";
import { Message } from "element-ui";

// 省区订单，商品数量统计
export function queryProvinceOrderDetailsStatistics(data) {
  return request({
    url: "/statistic/headquartersFinancialStatistics/queryProvinceOrderDetailsStatistics",
    method: "post",
    data,
  });
}
// 根据开始时间，结束时间，当日，当月标识查询全国相关收帐信息
export function queryFinancialCollectionStatistics(data) {
  return request({
    url: "/statistic/headquartersFinancialStatistics/queryFinancialCollectionStatistics",
    method: "post",
    data,
  });
}

// 根据省办orgCode获取地办分账信息
export function provinceOfficeOfAcquisitionPage(data) {
  return request({
    url: "/statistic/headquartersFinancialStatistics/provinceOfficeOfAcquisitionPage",
    method: "get",
    params: data,
  });
}
// 财务统计导出
export function exportStatistics(data) {
  request({
    url: "/statistic/headquartersFinancialStatistics/export",
    method: "post",
    responseType: "blob",
    data,
  }).then((response) => {
    // 处理返回的文件流
    const blob = response.data;
    if (blob && blob.size === 0) {
      Message.warning("内容为空，无法下载");
      return;
    }
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([blob]));
    link.download = "统计.xlsx";
    link.click();
    window.setTimeout(function () {
      window.URL.revokeObjectURL(link.href);
    }, 0);
  });
}

// 根据省办orgCode获取地办分账信息导出
export function exportProvinceStatistics(data) {
  request({
    url: "/statistic/headquartersFinancialStatistics/provinceOfficeOfAcquisitionExport",
    method: "get",
    responseType: "blob",
    params: data,
  }).then((response) => {
    // 处理返回的文件流
    const blob = response.data;
    if (blob && blob.size === 0) {
      Message.warning("内容为空，无法下载");
      return;
    }
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([blob]));
    link.download = "地区统计.xlsx";
    link.click();
    window.setTimeout(function () {
      window.URL.revokeObjectURL(link.href);
    }, 0);
  });
}
// 查询运城出货统计
export function queryApplicationStatisticsList(data) {
  return request({
    url: "/statistic/headquartersFinancialStatistics/queryApplicationStatisticsList",
    method: "get",
    params: data,
  });
}
// 新增编辑运城出货统计
export function updateApplicationStatistics(data) {
  return request({
    url: "/statistic/headquartersFinancialStatistics/updateApplicationStatistics",
    method: "post",
    data,
  });
}
// 新增编辑运城出货统计
export function queryApplicationStatisticsByOrgCodeOrShopId(data) {
  return request({
    url: "/statistic/headquartersFinancialStatistics/queryApplicationStatisticsByOrgCodeOrShopId",
    method: "get",
    params: data,
  });
}
// 删除对应运城统计信息
export function deleteApplicationStatisticsById(deleteId) {
  return request({
    url: `/statistic/headquartersFinancialStatistics/deleteApplicationStatistics?id=${deleteId}`,
    method: "delete",
  });
}
// 自适应统计设置报表
export function queryGoodsSalesEcharts(data) {
  return request({
    url: "/statistic/settings/adaption",
    method: "post",
    data,
  });
}

// 自适应统计设置报表导出
export function queryGoodsSalesEchartsExport(data, fileName = "") {
  return request({
    url: "/statistic/settings/export",
    method: "post",
    data,
    responseType: "blob",
  }).then((response) => {
    // 处理返回的文件流
    const blob = response.data;
    if (blob && blob.size === 0) {
      Message.warning("内容为空，无法下载");
      return;
    }
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([blob]));
    link.download = (fileName || "报表导出") + ".xlsx";
    link.click();
    window.setTimeout(function () {
      window.URL.revokeObjectURL(link.href);
    }, 0);
  });
}

// 查询新消肿，胃药的商品信息
export function getSelfControlGoodsType(data) {
  return request({
    url: "/statistic/goodsBaser/selectByGoodsCode",
    method: "get",
    params: data,
  });
}

export function excelExport(data) {
  return request({
    url: `/statistic/settings/export`,
    method: "post",
    responseType: "blob",
    data: data,
  })
    .then((response) => {
      // 处理返回的文件流
      console.log(response, "response.data");
      const blob = response.data;
      if (!response.data) {
        Message.warning("内容为空，无法下载");
        return;
      }
      if (blob && blob.size === 0) {
        Message.warning("内容为空，无法下载");
        return;
      }
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const contentDisposition = response.headers["content-disposition"];
      const fileName = decodeURIComponent(
        contentDisposition.substring(contentDisposition.indexOf("=") + 1)
      );
      console.log(fileName);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      window.setTimeout(function () {
        URL.revokeObjectURL(blob);
        document.body.removeChild(link);
        Message.success("导出成功");
      }, 0);
    })
    .catch((err) => {
      Message.warning("内容为空，无法下载");
    });
}

// 统计报表  云药库数据导出
export function queryFinancialCollectionStatisticsExport(data) {
  return request({
    url: `/statistic/headquartersFinancialStatistics/queryFinancialCollectionStatisticsExport`,
    method: "post",
    responseType: "blob",
    data: data,
  })
    .then((response) => {
      // 处理返回的文件流
      console.log(response, "response.data");
      const blob = response.data;
      if (!response.data) {
        Message.warning("内容为空，无法下载");
        return;
      }
      if (blob && blob.size === 0) {
        Message.warning("内容为空，无法下载");
        return;
      }
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const contentDisposition = response.headers["content-disposition"];
      const fileName = decodeURIComponent(
        contentDisposition.substring(contentDisposition.indexOf("=") + 1)
      );
      console.log(fileName);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      window.setTimeout(function () {
        URL.revokeObjectURL(blob);
        document.body.removeChild(link);
        Message.success("导出成功");
      }, 0);
    })
    .catch((err) => {
      Message.warning("内容为空，无法下载");
    });
}
// 财务 平台 商品对账单查询
export function queryProductMonthlyStatementPage(data) {
  return request({
    url: `/statistic/product/monthly/statement/page`,
    method: "post",
    data: data,
  });
}
// 财务 平台 商品对账单查询 统计
export function queryProductMonthlyStatementCollect(data) {
  return request({
    url: `/statistic/product/monthly/statement/collect`,
    method: "post",
    data: data,
  });
}
// 平台端  商品对账单 导出
export function productMmonthlyStatementExport(data) {
  return request({
    url: "/statistic/product/monthly/statement/export",
    method: "POST",
    data: data,
    responseType: "blob",
  });
}
// 平台端 关键词屏蔽
export function addSearchKeywordsFilter(data) {
  return request({
    url: `/statistic/search/searchKeywordsFilter/add`,
    method: "post",
    data: data,
  });
}

export function searchKeywordsList(params) {
  return request({
    url: `/statistic/search/searchKeywordsFilter/page`,
    method: "get",
    params,
  });
}

export function updateSearchKeywords(data) {
  return request({
    url: `/statistic/search/searchKeywordsFilter/edit`,
    method: "post",
    data: data,
  });
}

export function deleteSearchKeywords(id) {
  return request({
    url: `/statistic/search/searchKeywordsFilter/del/${id}`,
    method: "delete",
  });
}
// 获取平台对账单 可搜索供应商名称列表
export function queryDrugAgencyList(params) {
  return request({
    url: `/shop/shop/drugAgency/list`,
    method: "get",
    params,
  });
}
// 获取 贴敷商品明细列表
export function queryAdaptionGoodsList(params) {
  return request({
    url: `/statistic/sales/order/tf/split/page`,
    method: "post",
    data: params,
  });
}
// 贴敷商品明细导出
export function queryTFGoodsSalesExport(data, fileName = "") {
  return request({
    url: "/statistic/sales/order/tf/split/export",
    method: "post",
    data,
    responseType: "blob",
  }).then((response) => {
    // 处理返回的文件流
    const blob = response.data;
    if (blob && blob.size === 0) {
      Message.warning("内容为空，无法下载");
      return;
    }
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([blob]));
    link.download = (fileName || "贴敷明细导出") + ".xlsx";
    link.click();
    window.setTimeout(function () {
      window.URL.revokeObjectURL(link.href);
    }, 0);
  });
}

// 获取销售统计数据
export function getSalesStatistics(params) {
  return request({
    url: "/statistic/sales/order/dkx/split/page",
    method: "post",
    data: params,
  });
}

// 导出销售统计报表
export function exportSalesStatistics(data) {
  return request({
    url: "/statistic/sales/order/dkx/split/export",
    method: "post",
    data,
    responseType: "blob",
  }).then((response) => {
    // 处理返回的文件流
    const blob = response.data;
    if (blob && blob.size === 0) {
      Message.warning("内容为空，无法下载");
      return;
    }
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([blob]));
    link.download = "多控销分账明细.xlsx";
    link.click();
    window.setTimeout(function () {
      window.URL.revokeObjectURL(link.href);
      Message.success("导出成功");
    }, 0);
  });
}